import { editable } from '@/src/tools/contentModulesFieldName';
import { Icon } from '@/src/tools/icon';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import classNames from 'classnames';
import { get, isArray } from 'lodash';
import React from 'react';
import { Checkbox } from 'src/components/Antd';
import WarningIcon from 'src/components/Icon/Warning';
import { SectionContainer as Section } from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import css from './css.module.less';
import Dots from 'src/constrains/DotsMenuDrop';

const sectionProps = {
  size: 'small',
  bottomBorder: false,
  style: { paddingTop: 12, paddingBottom: 24 },
};
const BlockTitle = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    className,
    disabled,
    title,
    breakpoint,
    onCopy,
    id,
    headerErrorDependencies,
    validator,
    onReset,
    hasError,
    dotsFunction,
    dotsDisabled,
  } = props;

  const handleChange = (onChange) => {
    return (...args) => {
      if (!args[0]) {
        modal.error({
          title: getI18n('general.reminder'),
          content: getI18n(
            'salesChannelContent.index.blockTitleReminderContent',
          ),
          onOkText: getI18n('general.continue'),
          onCancel: () => {
            return;
          },
          onCancelText: getI18n('general.cancel'),
          onOk: () => {
            if (onReset) {
              onReset();
            }
            onChange(...args);
          },
        });
      } else {
        onChange(...args);
      }
    };
  };

  return (
    <Section {...sectionProps}>
      <div className={`${css.mldContainer} ${className}`}>
        <div className={css.titleContainer}>
          <div className={css.nameContainer}>
            {breakpoint === EPreviewSize.WIDE ? (
              <React.Fragment>
                <div
                  style={{ color: disabled ? '#999' : undefined }}
                  className={css.title}>
                  {title}
                </div>
                {dotsFunction && (
                  <div>
                    <Dots options={dotsFunction} />
                  </div>
                )}
              </React.Fragment>
            ) : (
              <>
                <Field name={`${id}_${editable}`}>
                  {(props, meta) => {
                    const { value } = props;
                    return (
                      <>
                        <Checkbox
                          checked={value}
                          onChange={handleChange(props.onChange)}
                          {...meta}>
                          <span
                            className={classNames(css.checkbox, {
                              [css.on]: !!value,
                              [css.off]: !value,
                            })}>
                            {getI18n('general.edit')}
                          </span>
                        </Checkbox>
                        <div className={css.rarePart}>
                          <Icon
                            type={'iconfile-copy'}
                            className={classNames(css.icon, {
                              [css.on]: !!value,
                              [css.off]: !value,
                              [css.cursor]: !value,
                            })}
                            onClick={!!value ? onCopy : void 0}
                          />
                          {dotsFunction && (
                            <div className={css.dots}>
                              <Dots
                                options={dotsFunction}
                                disabled={dotsDisabled}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    );
                  }}
                </Field>
              </>
            )}
          </div>

          <Error
            hasError={hasError}
            headerErrorDependencies={headerErrorDependencies}
            validator={validator}
            extra={{ breakpoint }}
          />
        </div>

        <Field
          shouldUpdate={(p, c) => {
            const pV = get(p, `${id}_${editable}`);
            const cV = get(c, `${id}_${editable}`);
            return pV !== cV;
          }}>
          {(props, meta, { getFieldsValue }) => {
            const { value } = props;
            const is_editable = get(value, [`${id}_${editable}`]);
            // console.log(`${id}_${editable}`);
            // console.log(`value`, value);
            // console.log(`breakpoint`, breakpoint);
            // console.log(`is_editable`, is_editable);
            // console.log(`disabled`, disabled);

            return (
              <div
                className={css.border}
                style={{
                  backgroundColor:
                    (is_editable || breakpoint === EPreviewSize.WIDE) &&
                    !disabled
                      ? '#61d77c'
                      : '#C0C0C0',
                }}></div>
            );
          }}
        </Field>
      </div>
    </Section>
  );
};
export default BlockTitle;

const Error = (props) => {
  const { headerErrorDependencies, validator, extra, hasError: _error } = props;
  return isArray(headerErrorDependencies) && validator ? (
    <Field
      shouldUpdate={(p, c) => {
        let shouldUpdate = false;
        (headerErrorDependencies || []).forEach((d) => {
          const pV = get(p, d);
          const cV = get(c, d);
          if (pV !== cV) {
            if (!shouldUpdate) {
              shouldUpdate = true;
            }
          }
        });
        return shouldUpdate;
      }}>
      {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
        const value = get(props, 'value');
        const res = validator(value, extra);
        const hasError = get(res, 'hasError');

        return hasError || _error ? <WarningIcon /> : null;
      }}
    </Field>
  ) : null;
};
